export default `
	sponsors {
		... on SponsorsItem {
			image {
				width
				height
				id
				url
			}
			caption
			itemUrl
		}
	}
`;
